import PropTypes from 'prop-types';
import { color as themeColor } from '../../../app/theme';

function IconLineMessage({ className, backgroundColor }) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="weoi7hr0sa"
        maskUnits="userSpaceOnUse"
        x="3"
        y="3"
        width="14"
        height="14"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.678 3.333c3.26.134 5.789 2.734 5.989 5.934V9.6c0 1-.2 2-.666 2.867-1.064 2.133-3.26 3.466-5.655 3.466-.932 0-1.797-.2-2.595-.533l-3.527 1.2c-.066.067-.133.067-.2.067-.199 0-.332-.067-.532-.2-.133-.133-.2-.4-.133-.667l1.198-3.533a6.983 6.983 0 0 1-.532-2.6c0-2.4 1.33-4.6 3.526-5.667.865-.466 1.797-.667 2.795-.667h.332zm4.126 8.6c.332-.733.532-1.466.532-2.266v-.333c-.2-2.534-2.196-4.534-4.724-4.667h-.266c-.732 0-1.53.2-2.196.533-1.73.867-2.795 2.534-2.795 4.467 0 .733.2 1.533.533 2.2.133.2.133.333.066.533l-.865 2.534 2.529-.867c.2 0 .399 0 .532.066a5.075 5.075 0 0 0 2.196.534c1.93 0 3.593-1 4.458-2.733z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#weoi7hr0sa)">
        <path fill={backgroundColor} d="M0 0h20v20H0z" />
      </g>
    </svg>
  );
}

IconLineMessage.defaultProps = {
  className: undefined,
  backgroundColor: themeColor.$2,
};

IconLineMessage.propTypes = {
  className: PropTypes.string,
  backgroundColor: PropTypes.string,
};

export default IconLineMessage;
